import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useFormErrorStore = defineStore('formError', () => {
  // State
  const formError = ref<string>('')
  const formErrorModal = ref<boolean>(false)
  const formErrorStatus = ref<string>('')

  function clear() {
    formError.value = ''
    formErrorModal.value = false
    formErrorStatus.value = ''
  }

  return {
    // State
    formError,
    formErrorModal,
    formErrorStatus,

    // Actions
    clear
  }
})
